module.exports = __webpack_public_path__ + "static/media/default.6b914f9c.jpg";